/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCardTypeDTO
 */
export interface UpdateCardTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardTypeDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardTypeDTO
     */
    costLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardTypeDTO
     */
    costLimitPeriod?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardTypeDTO
     */
    enabled?: boolean;
}

export function UpdateCardTypeDTOFromJSON(json: any): UpdateCardTypeDTO {
    return UpdateCardTypeDTOFromJSONTyped(json, false);
}

export function UpdateCardTypeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCardTypeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'costLimit': !exists(json, 'costLimit') ? undefined : json['costLimit'],
        'costLimitPeriod': !exists(json, 'costLimitPeriod') ? undefined : json['costLimitPeriod'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function UpdateCardTypeDTOToJSON(value?: UpdateCardTypeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'costLimit': value.costLimit,
        'costLimitPeriod': value.costLimitPeriod,
        'enabled': value.enabled,
    };
}

